import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconAiComment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Frame 4792",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Union",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.16675 1.66663C5.16675 1.39048 4.94289 1.16663 4.66675 1.16663C4.39061 1.16663 4.16675 1.39048 4.16675 1.66663V2.16663H3.66675C3.39061 2.16663 3.16675 2.39048 3.16675 2.66663C3.16675 2.94277 3.39061 3.16663 3.66675 3.16663H4.16675V3.66663C4.16675 3.94277 4.39061 4.16663 4.66675 4.16663C4.94289 4.16663 5.16675 3.94277 5.16675 3.66663V3.16663H5.66675C5.94289 3.16663 6.16675 2.94277 6.16675 2.66663C6.16675 2.39048 5.94289 2.16663 5.66675 2.16663H5.16675V1.66663Z",
				fill: "#818CF8"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Union_2",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3.33325 6.5C3.33325 6.22386 3.10939 6 2.83325 6C2.55711 6 2.33325 6.22386 2.33325 6.5V7H1.83325C1.55711 7 1.33325 7.22386 1.33325 7.5C1.33325 7.77614 1.55711 8 1.83325 8H2.33325V8.5C2.33325 8.77614 2.55711 9 2.83325 9C3.10939 9 3.33325 8.77614 3.33325 8.5V8H3.83325C4.10939 8 4.33325 7.77614 4.33325 7.5C4.33325 7.22386 4.10939 7 3.83325 7H3.33325V6.5Z",
				fill: "#818CF8"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 226 (Stroke)",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.24624 8.07741C8.57167 8.40285 8.57167 8.93049 8.24624 9.25593L2.58938 14.9128C2.26395 15.2382 1.73631 15.2382 1.41087 14.9128C1.08544 14.5873 1.08544 14.0597 1.41087 13.7343L7.06773 8.07741C7.39316 7.75198 7.9208 7.75198 8.24624 8.07741Z",
				fill: "#1E1B4B"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Star 2",
				d: "M11.4083 1.34533C11.7804 0.7503 12.6979 0.996167 12.7226 1.69748L12.7671 2.96357C12.7803 3.33686 13.0798 3.63645 13.4531 3.64958L14.7192 3.6941C15.4205 3.71877 15.6664 4.63635 15.0714 5.00837L13.9972 5.67998C13.6805 5.878 13.5708 6.28723 13.7461 6.61708L14.3406 7.73581C14.6699 8.3555 13.9982 9.02722 13.3785 8.69792L12.2597 8.10344C11.9299 7.92816 11.5207 8.03781 11.3226 8.35454L10.651 9.42873C10.279 10.0238 9.36142 9.77789 9.33676 9.07658L9.29223 7.81049C9.2791 7.43719 8.97952 7.13761 8.60622 7.12448L7.34014 7.07996C6.63882 7.05529 6.39295 6.13771 6.98798 5.76569L8.06218 5.09408C8.3789 4.89606 8.48855 4.48683 8.31327 4.15698L7.71879 3.03825C7.3895 2.41856 8.06122 1.74684 8.68091 2.07614L9.79963 2.67062C10.1295 2.8459 10.5387 2.73624 10.7367 2.41952L11.4083 1.34533Z",
				fill: "url(#paint0_linear_15608_276417)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Union_3",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.6667 11.1666C12.6667 10.8905 12.4429 10.6666 12.1667 10.6666C11.8906 10.6666 11.6667 10.8905 11.6667 11.1666V11.6666H11.1667C10.8906 11.6666 10.6667 11.8905 10.6667 12.1666C10.6667 12.4428 10.8906 12.6666 11.1667 12.6666H11.6667V13.1666C11.6667 13.4428 11.8906 13.6666 12.1667 13.6666C12.4429 13.6666 12.6667 13.4428 12.6667 13.1666V12.6666H13.1667C13.4429 12.6666 13.6667 12.4428 13.6667 12.1666C13.6667 11.8905 13.4429 11.6666 13.1667 11.6666H12.6667V11.1666Z",
				fill: "#818CF8"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_15608_276417",
		x1: 12.4265,
		y1: 1.0971,
		x2: 9.11589,
		y2: 8.67518,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#4F46E5" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#A5B4FC"
		})]
	}) })]
});
export default SvgIconAiComment;
